import React, { ReactElement } from 'react';
import { RecentFileRowProps } from '@biorad-lsg-tsc/instrument-family-plugin';
import { canOpenFile, getPathForFileType } from '../../frontend-common-libs/src/utils/fileUtils';
import { utcStringToDateTimeFormat } from '../../frontend-common-libs/src/common/display-formats';
import { PTCTempoFileIcon, PTCTempoFileRowType } from '../common';
import CommonRecentFileRow from '../../frontend-common-libs/recent-file-row';

export default function PTCTempoRecentFileRow({ item }: RecentFileRowProps): ReactElement {
  const id = item.get('id');
  const type = item.get('type');
  const displayType = PTCTempoFileRowType.getDisplayedFileType(type);
  const name = item.get('name');
  const updated = item.get('updated');
  const icon = <PTCTempoFileIcon type={type} />;
  const canOpen = canOpenFile(type);
  const lastTimeUpdate = utcStringToDateTimeFormat(updated);
  const path = getPathForFileType(type, id);

  return (
    <CommonRecentFileRow
      canOpenFile={canOpen}
      displayType={displayType}
      lastTimeUpdated={lastTimeUpdate}
      name={name}
      icon={icon}
      path={path}
      id={id}
    />
  );
}
